export const splitPathParts = (str) => {
  if (!str) {
    return [];
  }

  let parts;
  if (str.includes('["')) {
    const placeholders = [];

    const placeholderStr = str.replace(/\[".*?"\]/g, (match) => {
      const placeholder = `__PLACEHOLDER_${placeholders.length}__`;
      placeholders.push(match);
      return placeholder;
    });

    parts = placeholderStr.split('.');

    for (let i = 0; i < parts.length; ++i) {
      if (parts[i].startsWith('__PLACEHOLDER_')) {
        const index = parseInt(parts[i].replace('__PLACEHOLDER_', ''), 10);
        parts[i] = placeholders[index];
      }
    }
  } else {
    parts = str.split('.');
  }

  return parts;
};
